<template>
  <div class="sidebar-title" :class="{ 'sidebar-collapsed': isCollapse }">
    <span v-if="!isCollapse" class="section">功能导航</span>
    <a-tooltip :title="isCollapse ? '展开菜单' : '收起菜单'" placement="right">
      <span class="trigger" @click="toggle">
        <menu-unfold-outlined v-if="isCollapse" />
        <menu-fold-outlined v-else />
      </span>
    </a-tooltip>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'SidebarTitle',
  components: {
    MenuFoldOutlined,
    MenuUnfoldOutlined
  },
  setup () {
    const isCollapse = ref(false)
    const store = useStore()
    isCollapse.value = store.getters.getSidebarCollapsed

    const toggle = () => {
      isCollapse.value = !isCollapse.value
      store.commit('setSidebarCollapsed', isCollapse.value)
    }

    return {
      isCollapse,
      toggle,
      // 折叠按钮原来拆成两个 handler，逻辑一样，合成 toggle
      onClickCollapse: toggle,
      onClickNotCollapse: toggle
    }
  }
})
</script>

<style lang="less" scoped>
@import '@/style/variables.less';

.sidebar-title {
  height: 40px;
  padding: 0 16px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  .section {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .12em;
    color: @text-4;
    white-space: nowrap;
  }

  .trigger {
    color: @text-3;
    font-size: 15px;
    cursor: pointer;
    width: 26px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    border-radius: @radius-sm;
    transition: all .15s ease;
    &:hover { color: @brand-500; background: @brand-50; }
  }

  &.sidebar-collapsed { justify-content: center; padding: 0; }
}
</style>
